import { DATASET_LPG_VLGC } from '_legacy/models/Datasets';
import store from 'store';

export const blankKeyText = '(BLANKS)';
export const unknownKeyText = 'UNKNOWN';

export const unassignedQtyText = 'UNASSIGNED QTY';
export const unassignedCgoText = 'UNASSIGNED CGO';
export const unassignedChartererText = 'UNASSIGNED CHARTERER';
export const unassignedBuyerText = 'UNASSIGNED BUYER';
export const unassignedAreaText = 'UNASSIGNED AREA';
export const unassignedAreaGearlessText = 'UNASSIGNED AREA GEARLESS';
export const unassignedAreaGearedText = 'UNASSIGNED AREA GEARED';
export const unassignedDirectionText = 'UNASSIGNED DIRECTION';
export const unassignedLoadZoneText = 'UNASSIGNED LOAD ZONE';
export const unassignedCategoryText = 'UNASSIGNED CATEGORY';
export const unassignedOpportunityText = 'UNASSIGNED OPPORTUNITY';
export const unassignedOperatorText = 'UNASSIGNED OPERATOR';

const unassignedCPDateText = 'UNASSIGNED CPDATE';
const LpgVlgcUnassignedCPDateText = 'ON SUBS';

export const getUnassignedCPDateText = () => {
    const datasetId = store.getState()?.user?.group?.datasetId;
    if (datasetId == DATASET_LPG_VLGC) {
        return LpgVlgcUnassignedCPDateText;
    }
    return unassignedCPDateText;
};

export const isDefaultOrBlankValue = (value) => {
    return (
        !value ||
        value.length === 0 ||
        value === blankKeyText ||
        value === unassignedQtyText ||
        value === unassignedCgoText ||
        value === unassignedChartererText ||
        value === unassignedAreaText ||
        value === unassignedAreaGearlessText ||
        value === unassignedAreaGearedText ||
        value === unassignedDirectionText ||
        value === unassignedLoadZoneText ||
        value === unassignedCategoryText ||
        value === unassignedBuyerText ||
        value === unassignedOpportunityText ||
        value === unassignedOperatorText ||
        value === getUnassignedCPDateText()
    );
};
